import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Navbar, Nav, Button, Image } from 'react-bootstrap';
import { HashRouter as Router, Route, Routes, Link, NavLink } from 'react-router-dom';
import Denied from './Denied'
import TradeBlotter from '../components/trade/TradeBlotter';
import OrderBook from '../components/order/OrderBook';
import { CognitoAuthContext } from '../context/CognitoAuthContext';

const About = () => (
  <div>
    <h1>About Us</h1>
    <p>
      Learn more about Absolute Collateral and our mission to provide excellent services to our clients.
    </p>
  </div>
);

const UserGuide = () => (
  <div>
    <h1>User Guide</h1>
    <p>Follow these steps to enter a new trade or match an existing one.</p>

    <h3>Enter a new trade</h3>
    <ol>
      <li>Open <strong>Trades</strong> and click <strong>New Trade</strong>.</li>
      <li>Select the product (ISIN) and confirm the <strong>Entity</strong> (locked to your party).</li>
      <li>Choose the <strong>Counterparty</strong> and <strong>Type</strong> (buy/sell).</li>
      <li>Fill in key terms: <strong>Nominal</strong>, <strong>Rate</strong>, <strong>Haircut</strong>, <strong>Start</strong>, and <strong>End</strong>.</li>
      <li>Verify <strong>Cash Ccy</strong> and <strong>UL Ccy</strong> values.</li>
      <li>Click <strong>Send</strong> to submit the trade.</li>
    </ol>

    <h3>Match an existing trade</h3>
    <ol>
      <li>In <strong>Trades</strong>, locate the trade with status <strong>received</strong>.</li>
      <li>Click the trade row to open the details.</li>
      <li>Review the terms and click <strong>Confirm</strong> to match.</li>
      <li>If anything is incorrect, click <strong>Cancel</strong> and notify the counterparty.</li>
    </ol>

    <h3>Helpful tips</h3>
    <ul>
      <li>Use the search box and column filters to find trades quickly.</li>
      <li>Status meanings: <strong>sent</strong>, <strong>received</strong>, <strong>confirmed</strong>, <strong>cancelled</strong>, <strong>matured</strong>.</li>
      <li>Confirmed trades can be opened to view the confirmation and export a PDF.</li>
    </ul>
  </div>
);

const Config = () => (
  <div>
    <h1>Settings</h1>
    <p>
      Configure your system.
    </p>
  </div>
);


const LandingPage = () => {
  const { user, handleLogout } = useContext(CognitoAuthContext);
  //const partiesRef = gun.get(GUN.app_root).get(PARTIES);
  //const usersRef = gun.get(GUN.app_root).get(USERS);

  //const [parties, setParties] = useState([]);
  //const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  //const [currentParty, setCurrentParty] = useState(null);
  const [message, setMessage] = useState("");

  /** 
  useEffect(()=>{
    usersRef.map().once(async(encrypted, id)=>{
      if (encrypted) {
        const user = await decryptObject(name, encrypted)
        
        if (user.email === account.email ) {
          //console.log('user = ', user);
          //clearTimeout(timeout);
          setCurrentUser(user);
          gun.get(GUN.app_root).get(PARTIES).get(user.party).once(async(encrypted)=>{
            if (encrypted) {
              const party = await decryptObject(name, encrypted);
              setCurrentParty(party);
            }
          })
        }
        setUsers(prevUsers => ({ ...prevUsers, [id]: user }));
      }
    })

  },[])
  */

  useEffect(()=>{
    if (user) setCurrentUser(user)
  },[user])

  useEffect(()=>{
    if (currentUser) {
      setMessage(currentUser.email || currentUser.username)
    }
    else {
      setMessage('NOT AUTHORIZED');
    }
  },[currentUser])

  if (!currentUser) {
    return (
      <div style={{ backgroundColor: 'black', color: 'white', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <h1>Loading...</h1>
      </div>
    );
  }
  
  return (
      <div style={{ backgroundColor: 'black', color: 'white', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar bg="dark" variant="dark" fixed="top">
          <Container>
            <Navbar.Brand href="#home">
            <Image
                    src="logo-white.png" // Path from the public folder
                    alt="Absolute Collateral"
                    style={{ width: '400px', height: '30px' }} // adjust size as needed
              />
            </Navbar.Brand>
            <Button size='sm' variant='danger' onClick={() => handleLogout()}>Logout</Button>
          </Container>
        </Navbar>

        <Container fluid style={{ flex: 1, marginTop: '56px' }}>
          <Row>
          <Col className="d-flex justify-content-center align-items-center text-center" >
            {message}
          </Col>

          </Row>
          <Row>
            <Col md={1} style={{ paddingTop: '20px' }}>
              <Nav defaultActiveKey="/" className="flex-column">
              <Nav.Link as={NavLink} to="/" style={({ isActive }) => ({ color: isActive ? 'black' : 'white', backgroundColor: isActive ? 'white' : 'transparent' })}>Trades</Nav.Link>
              <Nav.Link as={NavLink} to="/guide" style={({ isActive }) => ({ color: isActive ? 'black' : 'white', backgroundColor: isActive ? 'white' : 'transparent' })}>User Guide</Nav.Link>
                {/** <Nav.Link as={NavLink} to="/orders" style={({ isActive }) => ({ color: isActive ? 'black' : 'white', backgroundColor: isActive ? 'white' : 'transparent' })}>Orders</Nav.Link> */ }
                
                <Nav.Link as={NavLink} to="/about" style={({ isActive }) => ({ color: isActive ? 'black' : 'white', backgroundColor: isActive ? 'white' : 'transparent' })}>About us</Nav.Link>
               
              </Nav>
            </Col>
            <Col md={11} style={{ paddingTop: '20px' }}>
              <Routes>
                <Route path="/" element={<TradeBlotter user={currentUser} />} />
                <Route path="/orders" element={<OrderBook />} />
                
                <Route path="/guide" element={<UserGuide />} />
                <Route path="/about" element={<About />} />
                <Route path='/denied' element={<Denied />} />
              </Routes>
            </Col>
          </Row>
        </Container>

        <footer style={{ backgroundColor: 'black', color: 'white', textAlign: 'center', padding: '10px 0' }}>
          &copy; Absolute Collateral 2024
        </footer>
      </div>
    
  );
};

export default LandingPage;
